/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Helmet } from "react-helmet";
import { useSimpliCity } from "cms/hooks/use-simplicity";
import { CircularProgress } from "@mui/material";
import { isTrue } from "../utils/empty-exists";

const LayoutWrapperCore = (props) => {

    const children = props.children;

    let { webpage, seo, loading } = useSimpliCity();

    const twCardType = seo?.tw_card_type ?? "summary_large_image";

    return (
        <>
            {seo &&
                <Helmet>
                    <link rel="canonical" href={seo?.url} />
                    <meta property="og:url" content={seo?.url} />
                    <meta name="twitter:url" content={seo?.url} />

                    <title>{seo?.title}</title>
                    <meta property="og:title" content={seo?.og_title} />
                    <meta name="twitter:title" content={seo?.tw_title} />

                    <meta name="description" content={seo?.description} />
                    <meta property="og:description" content={seo?.og_description} />
                    <meta name="twitter:description" content={seo?.tw_description} />

                    <meta name="og:type" content={seo?.og_type} />
                    <meta name="twitter:card" content={twCardType} />

                    <meta property="og:image" content={seo?.og_image} />
                    <meta name="twitter:image" content={seo?.tw_image} />
                </Helmet>
            }

            {/* Block Search indexing with noindex */}
            {isTrue(webpage?.exclude_from_search) &&
                <Helmet>
                    <meta name="robots" content="noindex"></meta>
                </Helmet>
            }

            {loading &&
                <div style={{
                    width: "100%",
                    height: "70vh",
                    gap: "24px",
                    display: "flex", flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "40px"
                }}
                >
                    <CircularProgress style={{ color: "#003E43" }} />
                </div>
            }

            {children}

        </>
    );
};

LayoutWrapperCore.displayName = "LayoutWrapperCore";
export { LayoutWrapperCore };
